
// region JS Imports

// region External Modules
import $ from "jquery"
import param from "jquery-param"
import URI from "urijs"
import { EventEmitter } from "events"
// endregion External Modules

// region Private Modules
import q_ajax_3 from "app/utils/q_ajax/q_ajax_3"
import NumbersFormatter from "app/numbers/formatter/index"

import StickyNavbarHandler from "app/sticky_navbar_handler/index"
import {
  Factory as PaginationFactory,
  Pagination,
} from "app/pagination"

import ImageLazyLoading from "widgets/image_lazyloading"
import BackgroundImageLazyLoading from "widgets/background_image_lazyloading"
// endregion Private Modules

// region Public Components
import {
  Factory as OverseasMarketingFilterBar,
  OverseasMarkingFilterBarDesktopCountry,
} from "concepts/buildings/overseas_marketing/filter_bar/desktop/for_country/index"
import NewDevelopmentBuildingsRow from "apps/spacious_website/pages/overseas_properties/shared/components/project_entry_row/wide/index"
import ListingsRowForSearchingDefault from "concepts/listings/row/for_searching/default/index"
import Listings_Contact_Button from "concepts/listings/contact/button/index"
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports


interface Selector {
  scope:                string | Element | JQuery
  count_text:           string | Element | JQuery
  properties_content:   string | Element | JQuery
  properties_list:      string | Element | JQuery
  section:              string | Element | JQuery
  section_content:      string | Element | JQuery
}
interface InputSelector {
  scope?:               string | Element | JQuery
  count_text?:          string | Element | JQuery
  properties_content?:  string | Element | JQuery
  properties_list?:     string | Element | JQuery
  section?:             string | Element | JQuery
  section_content?:     string | Element | JQuery
}
const DEFAULT_SELECTOR = {
  scope:              ".page--buildings--country_level_overseas_marketing_projects_page",
  count_text:         ".page-section--overseas-properties--count--text",
  properties_content: "#page-section--overseas-properties-content",
  properties_list:    ".page-section--overseas-properties-content--properties-list",
  section:            ".page-section--overseas-properties-section",
  section_content:    ".page-section--overseas-properties-section-content",
}


class OverseasMarketingFilter extends EventEmitter {
  protected selector: Selector
  protected $scope: JQuery
  protected $properties_content: JQuery
  protected $properties_list: JQuery
  protected $section: JQuery
  protected $count_text: JQuery

  protected overseas_marketing_filter_bar: OverseasMarkingFilterBarDesktopCountry
  protected paginate_instance: Pagination

  constructor(selector?: InputSelector){
    super()

    this.selector = Object.assign({}, DEFAULT_SELECTOR, selector)
    this.$scope = $(this.selector.scope)
    this.$properties_content = this.$scope.find(this.selector.properties_content)
    this.$properties_list = this.$properties_content.find(this.selector.properties_list)
    this.overseas_marketing_filter_bar = OverseasMarketingFilterBar.instance()
    this.$section = this.$properties_content.find(this.selector.section)
    this.$count_text = this.$scope.find(this.selector.count_text)

    this.paginate_instance = PaginationFactory.create()
    this.init_pagination()

    this.bind_action()
    this.created()
  }

  protected init_pagination(){
    this.paginate_instance.init(this.$properties_list)
    this.paginate_instance.onUpdate(() => {
      StickyNavbarHandler.scrollTo(this.$properties_list, {duration: 1000})
      this.update()
    })
    this.paginate_instance.initEvent()
  }
  protected bind_action(){
    this.overseas_marketing_filter_bar.on("val_change", () => {
      this.paginate_instance.resetPage()
      this.update()
    })
    this.overseas_marketing_filter_bar.on("category_change", () => {
      this.paginate_instance.resetPage()
      this.update()
      this.show_active_category_section()
    })
  }
  protected show_active_category_section(){
    const selected_category = this.overseas_marketing_filter_bar.getSelectedCategory()
    this.$section.filter(`[data-category=${selected_category}]`).addClass("active")
    this.$section.filter(`[data-category!=${selected_category}]`).removeClass("active")
  }
  protected update_listing_count(){
    this.$count_text.text(
      NumbersFormatter.numberWithCommas(
        this.$section.filter(".active").find(this.selector.section_content).data("listing-count") || 0
      ) || 0
    )
  }
  protected get_form_data(){
    return (Object.assign(this.overseas_marketing_filter_bar.get_form_data(), {page: this.paginate_instance.getPage()}) || {})
  }
  protected get_form_url(){
    return this.overseas_marketing_filter_bar.get_form_url()
  }
  protected initialize_active_category_filter(){
    this.$section = this.$properties_content.find(this.selector.section)
    this.show_active_category_section()
  }
  protected created(){
    this.init_child_components()
    this.update_listing_count()
  }
  protected init_child_components() {
    NewDevelopmentBuildingsRow.init()
    ListingsRowForSearchingDefault.init()
    Listings_Contact_Button.init()

    BackgroundImageLazyLoading.default_lazyload_instance().update()
    ImageLazyLoading.default_lazyload_instance().update()

    this.initialize_active_category_filter()
  }
  protected update(){
    this.overseas_marketing_filter_bar.setAsLoading()
    this.$properties_content.addClass("loading")

    const url_object = URI(this.get_form_url())
    url_object.query(param(this.get_form_data()))

    q_ajax_3({
      type:     "GET",
      url:      url_object.toString(),
      dataType: "HTML",
    })
    .then(({data}) => {
      this.overseas_marketing_filter_bar.setAsLoaded()
      this.$properties_list.html(data)
      this.$properties_content.removeClass("loading")
      this.init_pagination()
      this.init_child_components()
      this.update_listing_count()
    })
    .done()
  }
}

const Factory = {
  create(){
    return new OverseasMarketingFilter()
  },
}

export {
  Factory,
}
